import { GtmTracker } from '@/modules/common/services/analytics';

const trackEventNewInvestment = GtmTracker.trackerWithDefaultProps({
  page_screen: 'new_investment',
  digital_experience: 'investor',
  experience_section: 'investment_flow'
});

export function trackNewInvestment() {
  trackEventNewInvestment({
    event_type: 'load',
    event_name: 'new_investment'
  });
}

export function trackNewInvestmentClick(event_target: string) {
  trackEventNewInvestment({
    event_name: 'product',
    event_type: 'click',
    page_screen_section: 'investment_flow_body',
    event_target
  });
}

export function trackMyPortfolio() {
  trackEventNewInvestment({
    event_type: 'load',
    event_name: 'my_portfolio'
  });
}

export function trackMyPortfolioClick(event_target: string) {
  trackEventNewInvestment({
    event_name: 'portfolio',
    event_type: 'click',
    page_screen_section: 'investment_flow_body',
    event_target
  });
}

export function trackWealthInvestment() {
  trackEventNewInvestment({
    event_type: 'load',
    event_name: 'wealth_investment'
  });
}
